import { makeStyles } from "@material-ui/core/styles";
import { Colors } from "../../helpers/theme";

const PersonalInfoStyle = makeStyles((theme) => ({
    profilesetting: {
      margin: "40px 0 100px 0 ",
      [theme.breakpoints.down("xs")]: {
        margin: "24px 0 32px 0 ",
      },
      "& .MuiTypography-h2": {
        [theme.breakpoints.down("xs")]: {
          fontSize: "16px",
        },
      },
      "& .MuiButton-label": {
        fontSize: "12px",
      },
    },
    root: {
      flexGrow: 1,
      backgroundColor: theme.palette.background.paper,
      "& .MuiTabs-root": {
        "& .MuiButtonBase-root": {
          marginRight: theme.spacing(3),
          [theme.breakpoints.down("xs")]: {
            marginRight: "12px",
          },
        },
      },
    },
   
  }));

  const PersonalInfoTabStyle = makeStyles((theme) => ({
    root: {
      "& .socialbtn": {
        minWidth: "262px",
        minHeight: "48px",
        //   marginTop: theme.spacing(6),
        [theme.breakpoints.down("xs")]: {
          minWidth: "100%",
          marginTop: theme.spacing(1),
        },
      },
      "& .MuiButton-containedSizeLarge": {
        minWidth: "198px",
        [theme.breakpoints.down("xs")]: {
          marginTop: theme.spacing(2),
          minWidth: "100%",
        },
      },
    },
    large: {
      width: theme.spacing(18),
      height: theme.spacing(18),
    },
    small: {
      width: theme.spacing(4),
      height: theme.spacing(4),
      cursor: "pointer",
    },
  }));

  const TwoFAStyle = makeStyles((theme) => ({
    root: {
      "& .MuiButton-sizeLarge": {
        minWidth: "180px",
        minHeight: "48px",
        paddingTop:theme.spacing(1.4),
        paddingBottom:theme.spacing(1.4),
        paddingLeft:theme.spacing(5.5),
        paddingRight:theme.spacing(5.5),
        marginTop: theme.spacing(5),
        [theme.breakpoints.down("xs")]: {
          minWidth: "100%",
          marginTop: theme.spacing(4),
        },
      },
    },
    profileSuccess: {
      fontWeight: 700,
      color: Colors.greenLight,
    },
    profileError: {
      fontWeight: 700,
      color: Colors.errorRedDark,
    },
  }));

  const KYCTabStyle = makeStyles((theme) => ({
    root: {
      "& .MuiButton-containedSecondary": {
        minWidth: "130px",
        marginTop: theme.spacing(5),
        [theme.breakpoints.down("xs")]: {
          minWidth: "100%",
          marginTop: theme.spacing(4),
        },
      },
    },
    chip: {
      width: "auto",
      height: "26px",
      borderRadius: "78px",
      fontSize: "14px",
      justifyContent: "flex-start",
      fontWeight: 400,
      textTransform: 'capitalize',
      "&.approved": {
        backgroundColor: Colors.green,
        color: Colors.white,
        "& .MuiChip-avatar": {
          color: Colors.white,
        }
      },
      "&.unverified": {
        backgroundColor: Colors.lighterYellow,
        color: Colors.lightYellow,
        "& .MuiChip-avatar": {
          color: Colors.lightYellow,
        }
      },
      "&.inreview": {
        backgroundColor: Colors.pendingYellow,
        color: Colors.white,
        "& .MuiChip-avatar": {
          color: Colors.white,
        }
      },
      "&.waiting": {
        backgroundColor: Colors.pendingYellow,
        color: Colors.white,
        "& .MuiChip-avatar": {
          color: Colors.white,
        }
      },
      "&.incomplete": {
        backgroundColor: Colors.pendingYellow,
        color: Colors.white,
        "& .MuiChip-avatar": {
          color: Colors.white,
        }
      },
      "&.blocked": {
        backgroundColor: Colors.red,
        color: Colors.white,
        "& .MuiChip-avatar": {
          color: Colors.white,
        }
      },
      "&.rejected": {
        backgroundColor: Colors.red,
        color: Colors.white,
        "& .MuiChip-avatar": {
          color: Colors.white,
        }
      },
      "& .MuiChip-avatar": {
        width: "14px",
        height: "14px",
        marginRight: "1px",
      }
    },
  }));

  export {PersonalInfoStyle, PersonalInfoTabStyle, TwoFAStyle, KYCTabStyle };